import React from 'react';
import HomeInformation from './HomeInformacion'; 
export default function Home() {
  return (
    <>
      <HomeInformation /> 
    </>
  );
}
